// start:ng42.barrel
export * from './cancel-res.module';
export * from './cancel-res';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/cancel-res/index.ts